{
  "name": "ngx-srims",
  "version": "0.11.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --proxy-config proxy.conf.json",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.25",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^21.2.25",
    "@angular/compiler": "^21.2.25",
    "@angular/core": "^21.2.25",
    "@angular/forms": "^21.2.25",
    "@angular/platform-browser": "^21.2.25",
    "@angular/platform-browser-dynamic": "^21.2.25",
    "@angular/router": "^21.2.25",
    "@opentiny/fluent-editor": "^3.25.4",
    "@superset-ui/switchboard": "^0.20.3",
    "date-fns": "^3.5.0",
    "exceljs": "4.4.1-prerelease.0",
    "file-saver-es": "^2.0.5",
    "handlebars": "^4.7.10",
    "html2pdf.js": "^0.14.0",
    "lodash-es": "^4.17.23",
    "ng-zorro-antd": "^21.3.3",
    "rxjs": "~7.8.0",
    "tiny-uid": "^1.1.2",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^21.2.29",
    "@angular/cli": "^21.2.29",
    "@angular/compiler-cli": "^21.2.25",
    "@types/file-saver-es": "^2.0.3",
    "@types/lodash-es": "^4.17.12",
    "@types/w3c-web-hid": "^1.0.7",
    "less": "^4.2.0",
    "typescript": "~5.9.3"
  }
}
